import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { AssignLicenseSystemToOrgInput, AssignLicenseSystemToOrgPayload } from './generated/types';


const mutation = `mutation AssignLicenseSystemToOrg($input: AssignLicenseSystemToOrgInput!) {
    assignLicenseSystemToOrg(input: $input) {
        licenseSystemId
        succeeded
    }
}`;

export const useAssignLicenseSystemToOrg = (orgId: string) => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (licenseSystemId: string) => {

            const input: AssignLicenseSystemToOrgInput = {
                licenseSystemId,
                orgId,
            };

            const { data } = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    assignLicenseSystemToOrg: AssignLicenseSystemToOrgPayload;
                };
            }>);

            const isSucceeded = !!data.assignLicenseSystemToOrg.succeeded;

            return isSucceeded;
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['getOrganization', orgId] });
        },
    });
};